export enum PaymentStatus {
  APPROVED = 'approved',
  DECLINED = 'declined',
  SUCCESS = 'success',
  PARTIAL_SUCCESS = 'partial-success',
  SCHEDULED = 'scheduled', // Do not get this status on transaction level
  FAILED = 'failed',
  PROCESSING = 'processing',
  IN_PROGRESS = 'in_progress',

  // Values below are custom defined ones, can't expect them to come back from GPAL.
  UNKNOWN = 'unknown',
  TIMEOUT = 'timeout',
  SOME_FAILED = 'some_failed',
  SOME_PROCESSING = 'some_processing',
}
